module.exports = __webpack_public_path__ + "img/Slideshows-espace-client-gafam.3c7a7d7a.png";